import { render, staticRenderFns } from "./core_waybill.vue?vue&type=template&id=29d8b0bb&scoped=true&"
import script from "./core_waybill.vue?vue&type=script&lang=js&"
export * from "./core_waybill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8b0bb",
  null
  
)

export default component.exports